import { Button } from "components"
import { Fragment } from "react"
import { APPROVAL, useToggle } from "utils"
import { IoSendSharp } from "react-icons/io5"
import { ApprovalPaymentBillServiceSchema } from "../types"
import { ModalApprovePaymentBillService } from "./ModalApprovePaymentBillService"
import { PERMISION } from "security"

type ApprovalPaymentBillServiceActionProps = {
  data: ApprovalPaymentBillServiceSchema 
  refetch: () => void
}

export const ApprovalPaymentBillServiceAction = ({ data, refetch }: ApprovalPaymentBillServiceActionProps) => {
  const { isActive, toggle } = useToggle(false)

  return (
	<Fragment>
	  <Button
		type="button"
		color="ghost"
		permission={PERMISION.PURCHASES.TRANSACTION.APPROVAL_PAYMENT_BILL_SERVICE.UPDATE}
		onClick={toggle}
		disabled={Boolean(data?.approve_status === APPROVAL.REJECTED || data?.approve_status === APPROVAL.APPROVED)}
	  >
		<IoSendSharp />
	  </Button>

	  {isActive && <ModalApprovePaymentBillService toggle={toggle} data={data} refetch={refetch} />}
	</Fragment>
  )
}